import React from "react";
import ColorInit from "../../../shared/layout/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import Header from "../../../shared/layout/Header";
import { CartProvider } from "../../cart/context/CartContext";
import Footer from "../../../shared/layout/Footer";
import Wishlist from "../components/Wishlist";
import BottomFooter from "../../../shared/layout/BottomFooter";
const WishlistPage = () => {
    return (
        <CartProvider>
            <ColorInit color={'bigmall'} />
            <ScrollToTop smooth color="#ef253c" />
            <Header />
            <div className="container container-lg">
            <Wishlist />
            </div>
            <Footer />
            <BottomFooter />
        </CartProvider>
    );
}

export default WishlistPage;